import React, { useState, useEffect } from "react";
import styles from './TipoEntrega.module.css';
import ButtonVoltar from "../../../shared/components/ButtonVoltar";

export default function TipoEntrega() {
  const [opcao, setOpcao] = useState(localStorage.getItem("tipoEntrega") || "");
  const [horario, setHorario] = useState(localStorage.getItem("horaAgendada") || "");
  const [data, setData] = useState(localStorage.getItem("dataAgendada") || "");

  const opcoes = [
    { label: "Agora", value: "Agora" },
    { label: "Viagem", value: "Viagem" },
    { label: "Agendar para horário específico", value: "Agendar" }
  ];

  // Atualiza localStorage sempre que muda a opção
  const selecionarOpcao = (value) => {
    setOpcao(value);
    localStorage.setItem("tipoEntrega", value);

    if (value !== "Agendar") {
      localStorage.removeItem("dataAgendada");
      localStorage.removeItem("horaAgendada");
      setData("");
      setHorario("");
    }
  };

  // Atualiza localStorage para data/hora agendada
  const handleDataChange = (e) => {
    setData(e.target.value);
    localStorage.setItem("dataAgendada", e.target.value);
  };

  const handleHorarioChange = (e) => {
    setHorario(e.target.value);
    localStorage.setItem("horaAgendada", e.target.value);
  };

  return (
    <div className={styles.containerTipoEntrega}>
      <div className={styles.headerTipoEntrega}>
        <ButtonVoltar to={"/homecliente"} />
        <h2 className={styles.titulo}>Escolha o tipo de entrega</h2>
      </div>

      <div className={styles.formTipoEntrega}>
        <div className={styles.opcoesContainer}>
          {opcoes.map((opt) => (
            <div
              key={opt.value}
              className={`${styles.opcaoCard} ${opcao === opt.value ? styles.opcaoSelecionada : ""}`}
              onClick={() => selecionarOpcao(opt.value)}
            >
              {opt.label}
            </div>
          ))}
        </div>

        {opcao === "Agendar" && (
          <div className={styles.agendarContainer}>
            <label>
              Data
              <input
                type="date"
                value={data}
                onChange={handleDataChange}
                required
              />
            </label>
            <label>
              Horário
              <input
                type="time"
                value={horario}
                onChange={handleHorarioChange}
                required
              />
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
